// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3KdlX","rootSuccess":"CompleteLink_rootSuccess__yBs89","rootFailure":"CompleteLink_rootFailure__2WlJf","isDisabled":"CompleteLink_isDisabled__1GxOQ"};